"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("../_virtual/_tslib.js"),t=require("react/jsx-runtime"),i=require("styled-components"),a=require("@vds/video"),s=require("@plans/utilities"),r=require("../tile/index.js");function o(e){return e&&e.__esModule?e:{default:e}}var n=o(i);const d=n.default(r.default).withConfig({displayName:"TileContainer",componentId:"VDS__sc-19rzeqs-0"})`
  > div {
    overflow: hidden;
    video {
      pointer-events: auto;
    }
    @media (min-width: ${s.breakpoints.tabletSmall.min}) {
      border-radius: 32px !important;
    }
  }
`,c=n.default.img.withConfig({displayName:"StyledImage",componentId:"VDS__sc-19rzeqs-1"})`
  aspect-ratio: ${({aspectRatio:e})=>e};
  object-fit: cover;
  width: 100%;
`;exports.default=i=>{const{video:s,image:r,aspectRatio:o="16:9",onClick:n,surface:u}=i,l=e.__rest(i,["video","image","aspectRatio","onClick","surface"]);return t.jsxs(d,Object.assign({borderRadius:"24px",showBorder:!0},l,{padding:"0",aspectRatio:o,surface:u,role:!n&&"presentation"},{children:[s&&!r&&t.jsx(a.Video,Object.assign({surface:u,layout:"compact"},s,{aspectRatio:o})),r&&t.jsx(c,Object.assign({},r,{aspectRatio:o}))]}))};
